import { getImage, IGatsbyImageData } from 'gatsby-plugin-image';

import { ICustomGatsbyImageData } from './types';

/**
 * Resolves gatsby-plugin-image data from a Contentful asset and ensures
 * width/height are set so GatsbyImage reserves the correct aspect-ratio box.
 */
export function getContentfulImage(
  data: ICustomGatsbyImageData | null | undefined
): IGatsbyImageData | undefined {
  if (!data?.gatsbyImageData) {
    return undefined;
  }

  const image = getImage(data.gatsbyImageData);
  if (!image) {
    return undefined;
  }

  const sourceWidth = data.file?.details?.image?.width;
  const sourceHeight = data.file?.details?.image?.height;

  if (!image.width || !image.height) {
    return {
      ...image,
      width: image.width || sourceWidth,
      height: image.height || sourceHeight,
    };
  }

  return image;
}
